import { object, ref, string } from "yup";

import ICategory, { ICategoryInput } from "@/interfaces/product.category.interfaces";
import { ProductCategoryFormMessages } from "@/messages/product-categories/product-categories-form.messages";

import { CategoryFormData } from "./types";

const CODE_GENERATION = {
  LENGTH: 10,
  CHARACTERS: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789",
} as const;

function generateRandomCode(length: number, customerId: number): string {
  const chars = CODE_GENERATION.CHARACTERS;
  let randomChars = "";
  for (let i = 0; i < length; i++) {
    randomChars += chars.charAt(Math.floor(Math.random() * chars.length));
  }

  return randomChars + customerId.toString().slice(0, CODE_GENERATION.LENGTH - length);
}

export const buildInitialData = (
  customerId: number,
  isEditing: boolean,
  category?: ICategory | null
): CategoryFormData => {
  const customerIdStr = customerId.toString();
  const codeLength = CODE_GENERATION.LENGTH - customerIdStr.length;
  const codePrefix = generateRandomCode(codeLength, customerId);

  return {
    customerId: category?.customerId || customerId,
    code: category?.code || codePrefix,
    description: category?.description || "",
    parentId: category?.parentId || null,
    parentCode: category?.parentCode || "",
    changeDate: category?.changeDate || null,
    changeForId: category?.changeForId || "",
    level: category?.level || 1,
    isEditing: isEditing,
  };
};

export const buildFormSchema = (messages: ProductCategoryFormMessages) =>
  object().shape({
    description: string().required(messages.errorRequiredCategoryDescription),
    parentCode: string()
      .notOneOf([ref("code")], messages.errorParentCodeCannotBeSameAsCode)
      .nullable(),
  });

export const normalizeCreation = (formData: CategoryFormData): ICategoryInput => {
  const normalizedFormData: ICategoryInput = {
    ...formData,
  };

  return normalizedFormData;
};

export const normalizeUpdate = (formData: CategoryFormData): ICategoryInput => {
  const currentDate = new Date().toISOString();

  const normalizedFormData: ICategoryInput = {
    ...formData,
    changeDate: currentDate,
  };

  return normalizedFormData;
};
